var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAIconSelectBlue24 = function SvgAIconSelectBlue24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 2,
    fill: "#EBF2F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.625 7L10.3366 16.6214C10.1704 16.8408 9.9162 16.9781 9.63985 16.9976C9.3635 17.0171 9.09221 16.9169 8.89632 16.7229L7 14.8454",
    stroke: "#005EB8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgAIconSelectBlue24 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIj4KPHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiByeD0iMiIgZmlsbD0iI0VCRjJGOSIgLz4KPHBhdGggZD0iTTE3LjYyNSA3TDEwLjMzNjYgMTYuNjIxNEMxMC4xNzA0IDE2Ljg0MDggOS45MTYyIDE2Ljk3ODEgOS42Mzk4NSAxNi45OTc2QzkuMzYzNSAxNy4wMTcxIDkuMDkyMjEgMTYuOTE2OSA4Ljg5NjMyIDE2LjcyMjlMNyAxNC44NDU0IiBzdHJva2U9IiMwMDVFQjgiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiAvPgo8L3N2Zz4K";